"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobView = void 0;
const typeorm_1 = require("typeorm/browser");
const all_entities_1 = require("../all-entities");
const invoicing_target_1 = require("../invoicing-target");
const job_1 = require("../job");
const job_contact_person_1 = require("../job-contact-person");
const job_product_pending_order_1 = require("../job-product-pending-order");
const job_properties_1 = require("../job-properties");
const job_selection_1 = require("../job-selection");
const job_product_1 = require("../job_product");
const materialized_job_types_1 = require("../materialized/materialized-job-types");
const opportunity_option_1 = require("../opportunity-option");
const project_job_1 = require("../project-job");
const wallbox_install_priority_for_job_1 = require("../wallbox-install-priority-for-job");
const brand_for_job_view_1 = require("./brand-for-job-view");
const customer_for_job_view_1 = require("./customer-for-job-view");
const job_for_job_view_1 = require("./job-for-job-view");
const opportunity_for_job_view_1 = require("./opportunity-for-job-view");
const partner_for_job_view_1 = require("./partner-for-job-view");
const service_for_job_view_1 = require("./service-for-job-view");
let JobView = class JobView {
    sumPrice(fieldName) {
        return this.services.reduce((sum, service) => { var _a; return (_a = sum + service[fieldName]) !== null && _a !== void 0 ? _a : 0; }, 0);
    }
    get priceSellingSum() {
        return this.sumPrice('priceSellingSum');
    }
    get pricePurchasingSum() {
        return this.sumPrice('pricePurchasingSum');
    }
    get priceListsSum() {
        return this.sumPrice('priceListsSum');
    }
    getOrderedServices() {
        return this.services.sort((a, b) => service_for_job_view_1.ServiceForJobView.cmp(a, b));
    }
    get revenue() {
        let _revenue = 0;
        if (this.services.length > 0) {
            _revenue += this.services.reduce((sum, service) => {
                if (service.invoicingTarget === invoicing_target_1.InvoicingTargetEnum.CUSTOMER)
                    return sum + service.priceListsSum;
                if (service.invoicingTarget === invoicing_target_1.InvoicingTargetEnum.BRAND ||
                    service.invoicingTarget === invoicing_target_1.InvoicingTargetEnum.BRAND_1 ||
                    service.invoicingTarget === invoicing_target_1.InvoicingTargetEnum.BRAND_2)
                    return sum + service.priceSellingSum;
                return sum;
            }, 0);
        }
        if (this.products.length > 0 && this.products.length > 0) {
            _revenue += this.products.reduce((sum, product) => product.invoicingTarget !== invoicing_target_1.GeneralInvoicingTargetEnum.GID
                ? sum + product.priceSelling
                : sum, 0);
        }
        return _revenue;
    }
    get costs() {
        const totalBuyingPrice = this.products.reduce((sum, product) => {
            if (product.invoicingTarget == invoicing_target_1.GeneralInvoicingTargetEnum.GID)
                return sum + product.pricePurchasing;
            return sum;
        }, 0);
        const pricePurchasing = this.services.reduce((sum, service) => sum + service.pricePurchasingSum, 0);
        return pricePurchasing + totalBuyingPrice;
    }
    get gross_margin() {
        return this.revenue - this.costs;
    }
};
__decorate([
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
    }),
    __metadata("design:type", String)
], JobView.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 121,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], JobView.prototype, "apiId", void 0);
__decorate([
    (0, typeorm_1.Column)('date'),
    __metadata("design:type", String)
], JobView.prototype, "deliveryDate", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => job_for_job_view_1.JobForJobView, {
        prefix: 'job',
    }),
    __metadata("design:type", job_for_job_view_1.JobForJobView)
], JobView.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => opportunity_for_job_view_1.OpportunityForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_opportunity__c',
    }),
    __metadata("design:type", opportunity_for_job_view_1.OpportunityForJobView)
], JobView.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => brand_for_job_view_1.BrandForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_brand__c',
    }),
    __metadata("design:type", brand_for_job_view_1.BrandForJobView)
], JobView.prototype, "brand", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => brand_for_job_view_1.BrandForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'brand_1_id',
    }),
    __metadata("design:type", brand_for_job_view_1.BrandForJobView)
], JobView.prototype, "brand_1", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => brand_for_job_view_1.BrandForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'brand_2_id',
    }),
    __metadata("design:type", brand_for_job_view_1.BrandForJobView)
], JobView.prototype, "brand_2", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => brand_for_job_view_1.BrandForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_affiliate__c',
    }),
    __metadata("design:type", brand_for_job_view_1.BrandForJobView)
], JobView.prototype, "affiliate", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => customer_for_job_view_1.CustomerForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_customer__c',
    }),
    __metadata("design:type", customer_for_job_view_1.CustomerForJobView)
], JobView.prototype, "customer", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => customer_for_job_view_1.CustomerForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_customer_second__c',
    }),
    __metadata("design:type", customer_for_job_view_1.CustomerForJobView)
], JobView.prototype, "customer_2", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => partner_for_job_view_1.PartnerForJobView, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'job_professional__c',
    }),
    __metadata("design:type", partner_for_job_view_1.PartnerForJobView)
], JobView.prototype, "partner", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => service_for_job_view_1.ServiceForJobView, (sfj) => sfj.job, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'sfid',
        referencedColumnName: 'job',
    }),
    __metadata("design:type", Array)
], JobView.prototype, "services", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => all_entities_1.CustomService, (jcs) => jcs.job, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id__c',
        referencedColumnName: 'jobApiId',
    }),
    __metadata("design:type", Array)
], JobView.prototype, "customServices", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_properties_1.JobProperties),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id_for_properties',
        referencedColumnName: 'jobApiId',
    }),
    __metadata("design:type", job_properties_1.JobProperties)
], JobView.prototype, "properties", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => job_product_pending_order_1.JobProductPendingOrder, (jppo) => jppo.job),
    (0, typeorm_1.JoinColumn)({
        name: 'sfid',
        referencedColumnName: 'job',
    }),
    __metadata("design:type", Array)
], JobView.prototype, "productsPendingOrder", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => project_job_1.ProjectJob),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id_for_project',
        referencedColumnName: 'jobAPID',
    }),
    __metadata("design:type", project_job_1.ProjectJob)
], JobView.prototype, "projectJob", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_product_1.JobProduct, (jai) => jai.job, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id_for_product',
        referencedColumnName: 'job',
    }),
    __metadata("design:type", Array)
], JobView.prototype, "products", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => wallbox_install_priority_for_job_1.WallboxInstallPriorityForJob, (jobWallboxInstallPriority) => jobWallboxInstallPriority.job),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id_for_wallbox',
        referencedColumnName: 'jobApiId',
    }),
    __metadata("design:type", wallbox_install_priority_for_job_1.WallboxInstallPriorityForJob)
], JobView.prototype, "jobWallboxInstallPriority", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => materialized_job_types_1.MaterializedJobTypes, (jobTypes) => jobTypes.job),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id_for_jobtypes',
        referencedColumnName: 'jobApiId',
    }),
    __metadata("design:type", materialized_job_types_1.MaterializedJobTypes)
], JobView.prototype, "jobTypes", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_contact_person_1.JobContactPerson, (jobContactPerson) => jobContactPerson.jobs),
    (0, typeorm_1.JoinColumn)({
        name: 'api_id__c',
    }),
    __metadata("design:type", job_contact_person_1.JobContactPerson)
], JobView.prototype, "jobContactPerson", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => job_selection_1.JobSelection, (jcs) => jcs.job, {
        eager: true,
    }),
    __metadata("design:type", Array)
], JobView.prototype, "selections", void 0);
JobView = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: (connection) => {
            return connection
                .createQueryBuilder()
                .select('job')
                .addSelect('job.sfid', 'sfid')
                .addSelect('job.owner__c', 'owner__c')
                .addSelect('job.api_id__c', 'api_id__c')
                .addSelect('job.api_id__c', 'api_id_for_project')
                .addSelect('job.api_id__c', 'api_id_for_wallbox')
                .addSelect('job.api_id__c', 'api_id_for_jobtypes')
                .addSelect('job.api_id__c', 'api_id_for_product')
                .addSelect('job.api_id__c', 'api_id_for_properties')
                .addSelect('opportunity_options.brand_1', 'brand_1_id')
                .addSelect('COALESCE(job.brand2__c, opportunity_options.brand_2)', 'brand_2_id')
                .addSelect('COALESCE(job.date_end__c, job.appointment_customer_end__c,job.appointment_customer_start__c,job.createddate)', 'delivery_date')
                .from(job_1.Job, 'job')
                .leftJoin(opportunity_option_1.OpportunityOption, 'opportunity_options', '(opportunity_options.opportunity_sfid = job.opportunity__c)');
        },
    })
], JobView);
exports.JobView = JobView;
//# sourceMappingURL=job-view.js.map